import { useState } from "react";

import "./SecureConfirm.css";

type SecureConfirmProps = {
  open: boolean;
  title: string;
  message: string;

  confirmLabel?: string;
  cancelLabel?: string;

  danger?: boolean;

  loading?: boolean;

  onCancel: () => void;

  onConfirm: (
    password: string,
  ) => Promise<void>;
};

export default function SecureConfirm({
  open,
  title,
  message,

  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",

  danger = false,

  loading = false,

  onCancel,
  onConfirm,
}: SecureConfirmProps) {
  const [password, setPassword] =
    useState("");

  const [error, setError] =
    useState("");

  if (!open) {
    return null;
  }

  async function handleConfirm() {
    if (!password) {
      setError(
        "Digite sua senha para continuar.",
      );

      return;
    }

    try {
      setError("");

      await onConfirm(password);

      setPassword("");
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : "Não foi possível confirmar esta ação.",
      );
    }
  }

  function handleCancel() {
    if (loading) {
      return;
    }

    setPassword("");
    setError("");

    onCancel();
  }

  return (
    <div
      className="secure-confirm-backdrop"
      onClick={handleCancel}
    >
      <div
        className="secure-confirm"
        onClick={(event) =>
          event.stopPropagation()
        }
      >
        <div className="secure-confirm-header">
          <div>
            <span>
              CONFIRMAÇÃO DE SEGURANÇA
            </span>

            <h3>{title}</h3>
          </div>

          <button
            type="button"
            onClick={handleCancel}
            disabled={loading}
          >
            ×
          </button>
        </div>

        <p className="secure-confirm-message">
          {message}
        </p>

        <label>
          Confirme sua senha

          <input
            type="password"
            value={password}
            onChange={(event) =>
              setPassword(
                event.target.value,
              )
            }
            placeholder="Digite sua senha"
            autoComplete="current-password"
            autoFocus
            onKeyDown={(event) => {
              if (
                event.key === "Enter"
              ) {
                handleConfirm();
              }
            }}
          />
        </label>

        {error && (
          <div className="secure-confirm-error">
            {error}
          </div>
        )}

        <div className="secure-confirm-actions">
          <button
            type="button"
            className="secure-cancel"
            onClick={handleCancel}
            disabled={loading}
          >
            {cancelLabel}
          </button>

          <button
            type="button"
            className={
              danger
                ? "secure-danger"
                : "secure-submit"
            }
            onClick={
              handleConfirm
            }
            disabled={loading}
          >
            {loading
              ? "Confirmando..."
              : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}